(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-ac-collections]').forEach(menu => {
      if (menu.dataset.acReady) return;
      menu.dataset.acReady = 'true';
      const categories = [...menu.querySelectorAll('[data-ac-category]')];
      const panels = [...menu.querySelectorAll('[data-ac-panel]')];
      if (!categories.length) return; // Flat collection links remain a browsable image grid.
      function activate(category) {
        categories.forEach(item => {
          const active = item === category;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-expanded', String(active));
        });
        panels.forEach(panel => panel.hidden = panel.dataset.acPanel !== category.dataset.acCategory);
      }
      categories.forEach(category => {
        category.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') activate(category);
        });
        category.addEventListener('click', event => {
          event.preventDefault();
          activate(category);
        });
        category.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); activate(category); }
        });
      });
      activate(categories[0]);
    });
    scope.querySelectorAll('details.ac-menu').forEach(menu => {
      if (menu.dataset.acReady) return;
      menu.dataset.acReady = 'true';
      const hoverDesktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      menu.addEventListener('pointerenter', event => {
        if (!hoverDesktop.matches || event.pointerType !== 'mouse') return;
        cancelClose();
        document.querySelectorAll('details.ac-menu[open]').forEach(other => {
          if (other !== menu) other.open = false;
        });
        menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (!hoverDesktop.matches || event.pointerType !== 'mouse') return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
        }, 180);
      });
      menu.addEventListener('focusin', cancelClose);
      menu.addEventListener('focusout', () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false;
        }, 180);
      });
      hoverDesktop.addEventListener('change', () => { cancelClose(); menu.open = false; });
      menu.addEventListener('toggle', () => {
        menu.querySelector(':scope > summary').setAttribute('aria-expanded', String(menu.open));
        if (menu.open) {
          document.querySelectorAll('details.ac-menu[open]').forEach(other => {
            if (other !== menu) other.open = false;
          });
        }
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('details.ac-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.ac-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector(':scope > summary').focus();
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
